import { Component, OnInit, ViewChild, ElementRef, Renderer2, HostListener, QueryList, ViewChildren, OnDestroy } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { Router, Event, NavigationStart, NavigationEnd, ActivatedRoute } from '@angular/router';
import { RouteComponent } from '../route/route.component';
import { SubmitComponent } from '../submit/submit.component';
import { WithdrawComponent } from '../withdraw/withdraw.component';
import { MessageBoxComponent } from '../message-box/message-box.component';
import { FaqViewComponent } from '../faq-view/faq-view.component';
import { DocumentTemplateComponent } from '../document-template/document-template.component';
import { ChangePasswordComponent } from 'src/app/personalization/change-password/change-password.component';
import { NotificationStoreComponent } from 'src/app/administration/notification-store/notification-store.component';
import { CommonService } from 'src/app/services/common.service';
import { LogOutModel, Menu, ModuleFeatureModel } from 'src/app/models/common';
import { IST_APP, EAP_APP, GM_APP, ModuleMenu } from 'src/app/models/common';
import { HeadService } from 'src/app/services/common/headservice';
import { HelpViewComponent } from '../help-view/help-view.component';
import { Location } from '@angular/common';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ViewProfileComponent } from 'src/app/personalization/view-profile/view-profile.component';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { SubmitValidationsComponent } from '../submit-validations/submit-validations.component';
import { ChangeLogComponent } from '../change-log/change-log.component';
import { DeleteBoxComponent } from '../delete-box/delete-box.component';
import { Organization, ROUTE } from 'src/app/models/um/organization';
import { UmSummaryService } from 'src/app/services/um/um-summary.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IstDataShareService } from 'src/app/services/ist/ist-datashare.service';
import { GrantsDatashareService } from 'src/app/services/grants/grants-datashare.service';
import { ScheduleReviewComponent } from '../schedule-review/schedule-review.component';
import { ApplicationInfoComponent } from '../application-info/application-info.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit,OnDestroy {
  moduleUrl;
  requestId;
  routerLinkUrl;
  menuItems: Menu[];
  leftMenuItems: Menu[];
  topMenuItems: Menu[];
  menu: Menu;
  module;
  title = 'Medrion';
  userDetails = null;
  selectedRoute;
  username;
  currentDate;
  app_ext: Boolean = false;
  isChecked: number = 2;
  mainHeading;
  userType;
  setQueryParams;
  screenType;
  IsReviewAvailable: boolean;
  isSubmit: boolean;
  isRoute: boolean;
  isReturn: boolean;
  isWithdraw: boolean;
  isReject: boolean;
  isOnHold: boolean;
  isRelease: boolean;
  isDiscard: boolean;
  isAssign: boolean;
  isClose: boolean = true;
  istapp: IST_APP;
  eapapp: EAP_APP;
  grantsapp: GM_APP;
  operation: string;
  menudata: ModuleMenu;
  formState: string;
  src: string;
  organization: string;
  orgCode: string;
  appdata: string;
  isOwnUser: boolean;
  OwnerID: string = "";
  isCoOwnUser: boolean;
  HasCoOwnerPermission: boolean;
  isAdmin: boolean;
  code: string;
  raisedBy: string;
  created: string;
  updated: string;
  //notificationCount: number;
  timeout: any;
  notificationCount: Observable<any> = null;
  HasChangeLog: boolean = false;
  HasAdminPermissions: boolean = false;
  SubModule: string = "";
  IsOnlyView: boolean = false;
  leftmenus: Menu[] = [];
  HasMyReviewsPrevilage: boolean;
  tagetFrom="";
  currentbuildversion: any;
  MappedApplicationType:string ="";
  MappedWorkFlowName :string ="";
 
  // @ViewChild('sidenav') sidenav: SidenavComponent;
  // @ViewChild('acc') acc: SidenavComponent;
  // @ViewChildren(SBItemComponent) collapses: QueryList<SBItemComponent>[];

  constructor(
    private activatedRoute: ActivatedRoute,
    private ngbModal: NgbModal,
    private userService: UserService,
    private router: Router, private renderer: Renderer2,
    private commonService: CommonService,
    private modalService: NgbModal,
    private location: Location,
    private header: HeadService,
    private summaryService: IstSummaryService,
    private UmsummaryService: UmSummaryService,
    private dataShare: IstDataShareService,
    //private grantsdataShare: GrantsDatashareService,
    private GrantsShare: GrantsDatashareService,

  ) {
    this.src = "../assets/images/superadmin-logo.png";
    // this.header.getHeader().subscribe(message => {
    //   this.menudata = message;
    //   //this.formState = message.formstate;
    //  // if (message !== null && message !== undefined)
    //    // this.refreshMenu(message.module, message.operation);
    // });

    this.activatedRoute.queryParams.subscribe(params => {
      if (params) {
        this.setQueryParams = params;
        params && params['app_ext'] ? this.app_ext = true : this.app_ext = false;
        window['app_ext'] = this.app_ext;

        this.screenType = params['screen_type'];
        this.moduleUrl = '/home/' + params['module'] + '/' + params['screen_type'] + '/';
        this.requestId = params['id'];
        this.module = params['module'];
        this.SubModule = params["submodule"];
        if(params["IsOnlyView"])
        { 
          this.IsOnlyView=true;
        }
        // else{
        //   if(this.tagetFrom=="all")
        //     {
        //       this.IsOnlyView=true;
        //     }
        //     else{
        //       this.IsOnlyView=false;
        //     }
        // }

        window['moduleType'] = this.module;
        this.routerLinkUrl = this.moduleUrl + 'application-ext/:' + this.requestId;
        switch (this.module) {
          case "ist":
            this.dataShare.ApplicationID.subscribe(x => {
              this.getChangeLogInfo(x, this.module);

            });
            break;
          case "eap":
            break;
          case "grants":
            this.GrantsShare.GrantApplicationID.subscribe(x => {
              this.getChangeLogInfo(x, this.module);
            });
            break;
        }

      }
    });
  }
 
  ngOnInit() {
    // this.istapp=null;
    //  this.eapapp=null;
    //  this.grantsapp=null;
    // this.commonService.removeISTApp();
    // this.commonService.removeEAPApp();
    // this.commonService.removeGrantsApp();

    this.userDetails = this.userService.getUserDetais();
    if (this.userDetails != null && this.userDetails.USER_TYPE != 'A')
      this.getNotificationCountInit();
    this.isOwnUser = false;
    this.isCoOwnUser = false;
    this.HasCoOwnerPermission = false;

    this.HasMyReviewsPrevilage = this.userDetails.HasMyReviewsPrevilage;
    this.isAdmin = this.userDetails.IsAdmin;
    this.userType = this.userService.getUserType();
    this.username = this.userDetails.FIRST_NAME;
    if (this.userDetails.LAST_NAME !== null && this.userDetails.LAST_NAME !== undefined)
      this.username = this.username + " " + this.userDetails.LAST_NAME;
    this.currentDate = new Date().toLocaleString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    this.header.getHeader().subscribe(message => {
      this.menudata = message;
      if (message !== null && message != undefined) {
        this.tagetFrom=message.tagetFrom;
        // if(this.tagetFrom=="all")
        //   {
        //     this.IsOnlyView=true;
        //   }
        //   else{
        //     this.IsOnlyView=false;
        //   }
        if (message.formstate === 'Onhold') {
          this.formState = "On-Hold";
          this.isRelease = true;
        }
        else
          this.formState = message.formstate;
      }
      if (message !== null && message !== undefined){
       // if(this.istapp == null && this.eapapp==null && this.grantsapp==null)
        {
          this.refreshMenu(message.module, message.operation);
        }
      }
    });

    this.orgCode = this.userService.getOrgCode();
    if (this.orgCode !== "") {
      const img = this.userService.getLogoImage();
      if (img !== null && img !== undefined) {
        this.src = img;
      }
      else {
        this.userService.getLogo(this.orgCode).subscribe(result => {
          if (result === null || result === undefined || result === '') {
            this.src = "../assets/images/superadmin-logo.png";
          }
          else {
            if (result.FileExt == 'svg') {
              this.src = 'data:image/svg+xml;base64,' + result.Image;
            }
            else {
              this.src = 'data:image/png;base64,' + result.Image;
            }
            this.userService.setLogoImage(this.src);
          }
        });
      }
    }
    var AtleastOneMenu = this.userDetails.FEATURES.filter(function (item) {
      return (item.Id == "istconsole" || item.Id == "eapconsole" || item.Id == "grantsconsole" || item.Id == "general" || item.Id == "auditlog" || item.Id == "analyticsconsole")
    })[0];
    if (AtleastOneMenu != null && AtleastOneMenu != undefined) {
      this.HasAdminPermissions = true;
    }

    this.commonService.getCurrentVersion().subscribe(result=>{ 
      this.currentbuildversion = result.Data;
  })
  
 // this.currentbuildversion = this.userService.getCurrentBuildVersion();
  }
  
  ngOnDestroy() {
    this.close();
    // Clear the pending timeout so it doesn't keep running
    clearTimeout(this.timeout);
  }

  getChangeLogInfo(AppId: string, Module_id: string) {
    if (AppId != "" && AppId != null && AppId != undefined && this.HasChangeLog == false) {
      this.commonService.GetChangeLogInfo(AppId, Module_id).subscribe(result => {
        this.HasChangeLog = result.Data;
      })
    }
  }

  refreshMenu(module: string, operation: string) {
    var OrgDetail = this.commonService.getOrganizationObject(this.userService.getOrgCode());
    this.isOwnUser = false;
    this.isCoOwnUser = false;
    this.HasCoOwnerPermission = false;
    this.module = module;
    this.userType = this.userService.getUserType();
    this.userDetails = this.userService.getUserDetais();
    this.operation = operation;
    this.code = "";
    switch (this.module) {
      case 'IST':
        this.istapp = this.commonService.getISTApp();
        this.eapapp = null;
        this.grantsapp = null;
        if (this.istapp !== null) {
          this.MappedApplicationType=this.istapp.MappedApplicationType;
          this.MappedWorkFlowName =this.istapp.MappedWorkFlowName;
          this.OwnerID = this.istapp.CREATED_BY;
          this.formState = this.istapp.CurrentStatusExt;
          if (this.istapp.CREATED_BY === this.userDetails.ID)
            this.isOwnUser = true;
          if (this.istapp.COOWNER === this.userDetails.ID)
            this.isCoOwnUser = true;
          if (this.istapp != null && this.istapp.HasCOOWNERPermission == true) {
            this.HasCoOwnerPermission = true;
          }
        }
        else {
          this.formState = "Draft";
          this.mainHeading = "New "+OrgDetail.IST_DISPLAY_NAME+" application";
        }
        this.getMenu();
        break;
      case 'EAP':
        this.eapapp = this.commonService.getEAPApp();
        this.istapp = null;
        this.grantsapp = null;
        if (this.eapapp !== null) {
          this.MappedApplicationType=this.eapapp.MappedApplicationType;
          this.MappedWorkFlowName =this.eapapp.MappedWorkFlowName;
          this.OwnerID = this.eapapp.CREATED_BY;
          this.formState = this.eapapp.CurrentStatusExt;
          if (this.eapapp.CREATED_BY === this.userDetails.ID)
            this.isOwnUser = true;
          if (this.eapapp != null && this.eapapp.HasCOOWNERPermission == true) {
            this.HasCoOwnerPermission = true;
          }
        }
        else {
          this.formState = "Draft";
          this.mainHeading = "New "+OrgDetail.EAP_DISPLAY_NAME+" Request";
        }
        this.getMenu();
        break;
      case 'GRANTSCME':
      case 'GRANTSSPONSORSHIP':
      case 'GRANTSCHARITABLE':
        this.grantsapp = this.commonService.getGrantsApp();
        this.MappedApplicationType=this.grantsapp.MappedApplicationType;
        this.MappedWorkFlowName =this.grantsapp.MappedWorkFlowName;
        this.istapp = null;
        this.eapapp = null;
        if (this.grantsapp !== null && (this.grantsapp.CREATED_BY === this.userDetails.ID))
          this.isOwnUser = true;
        if (this.grantsapp !== null && (this.grantsapp.COOWNER === this.userDetails.ID))
          this.isCoOwnUser = true;
        if (this.grantsapp != null && this.grantsapp.HasCOOWNERPermission == true) {
          this.HasCoOwnerPermission = true;
        }
        if (this.grantsapp !== null) {
          this.OwnerID = this.grantsapp.CREATED_BY;
          this.formState = this.grantsapp.CurrentStatusExt;
        }
        else {
          this.formState = "Draft";
          this.mainHeading = "New Grants Request";
          if (this.module == "GRANTSCME") {
            this.mainHeading = "New "+OrgDetail.CME_DISPLAY_NAME+" application";
          }
          if (this.module == "GRANTSSPONSORSHIP") {
            this.mainHeading = "New "+OrgDetail.SPONSERSHIP_DISPLAY_NAME+" application";
          }
          if (this.module == "GRANTSCHARITABLE") {
            this.mainHeading = "New "+OrgDetail.CHARITY_DISPLAY_NAME+" application";
          }
        }
        this.getMenu();
        break;
    }

  }

  getMenu() {
    var OrgDetail = this.commonService.getOrganizationObject(this.userService.getOrgCode());
    let model = new ModuleFeatureModel();
    switch (this.module) {
      case 'IST':
        if (this.operation === 'New') {
          this.dataShare.Application_Type_ID.subscribe((appTypeId)=>{
            if(appTypeId)
            {
              model.Id = "-1";
              model.Code = "IST";
              model.State =  "1";
              model.Operation = this.operation;
              model.TargetForm = this.tagetFrom;
              model.ApplicationTypeId=appTypeId;
              this.mainHeading = "New "+OrgDetail.IST_DISPLAY_NAME+" application";
              this.commonService.getMenu(model).subscribe((result) => {
                this.menuItems = result;
                this.setMenuItems("IST");
              })
            }
          });
        }
        else {
          model.Id = this.menudata.appId;
          model.Code = "IST";
          model.State =  this.getOperation("IST");
          model.Operation = this.operation;
          model.TargetForm = this.tagetFrom;

          this.mainHeading = this.operation +" "+OrgDetail.IST_DISPLAY_NAME+" application";
          if (this.istapp !== null) {
            this.code = this.istapp.APPLICATION_CODE;
            this.raisedBy = this.istapp.PHYSICIANNAME;
            this.created = this.istapp.CREATEDON;
            this.updated = this.istapp.UPDATEDON;

            this.commonService.getMenu(model).subscribe((result) => {
              this.menuItems = result;
              this.setMenuItems("IST");
            })
          }
        }

        break;
      case 'GRANTSCME':
      case 'GRANTSSPONSORSHIP':
      case 'GRANTSCHARITABLE':  
        if (this.operation === 'New') {
          this.dataShare.Application_Type_ID.subscribe((appTypeId)=>{
            if(appTypeId)
            {
              this.mainHeading = "New Grants Request";
              if (this.module == "GRANTSCME") {
                this.mainHeading = "New "+OrgDetail.CME_DISPLAY_NAME+" Request";
              }
              if (this.module == "GRANTSSPONSORSHIP") {
                this.mainHeading = "New "+OrgDetail.SPONSERSHIP_DISPLAY_NAME+" Request";
              }
              if (this.module == "GRANTSCHARITABLE") {
                this.mainHeading = "New "+OrgDetail.CHARITY_DISPLAY_NAME+" Request";
              }
              model.Id = "-1";
              model.Code = this.module;
              model.State = "1";
              model.Operation = this.operation;
              model.TargetForm = this.tagetFrom;
              model.ApplicationTypeId=appTypeId;
              this.commonService.getMenu(model).subscribe((result) => {
                this.menuItems = result;
                this.setMenuItems("GRANTS");
              })
           }
         });
        }
        else {

          model.Id = this.menudata.appId;
          model.Code = this.module;
          model.State =  this.getOperation("GRANTS");
          model.Operation = this.operation;
          model.TargetForm = this.tagetFrom;

          this.mainHeading = this.operation + " Grants application";
          if (this.module == "GRANTSCME") {
            this.mainHeading = this.operation +" "+OrgDetail.CME_DISPLAY_NAME+" application";
          }
          if (this.module == "GRANTSSPONSORSHIP") {
            this.mainHeading =this.operation +" "+OrgDetail.SPONSERSHIP_DISPLAY_NAME+" application";
          }
          if (this.module == "GRANTSCHARITABLE") {
            this.mainHeading = this.operation +" "+OrgDetail.CHARITY_DISPLAY_NAME+" application";
          }
          if (this.grantsapp !== null) {
            if (this.grantsapp.APPLICATION_CODE === null || this.grantsapp.APPLICATION_CODE === undefined)
              this.code = "undefined";
            else
              this.code = this.grantsapp.APPLICATION_CODE;

            this.raisedBy = this.grantsapp.PHYSICIANNAME;
            this.created = this.grantsapp.CREATEDON;
            this.updated = this.grantsapp.UPDATEDON;
          }

          this.commonService.getMenu(model).subscribe((result) => {
            this.menuItems = result;
            this.setMenuItems("GRANTS");
          })
        }


        break;
      case 'EAP':      
        if (this.operation === 'New') { 
          this.dataShare.Application_Type_ID.subscribe((appTypeId)=>{
            if(appTypeId)
            {
              model.Id = "-1";
              model.Code = "EAP";
              model.State =  "1";
              model.Operation = this.operation;
              model.TargetForm = this.tagetFrom;
              model.ApplicationTypeId=appTypeId;
              this.mainHeading = "New "+OrgDetail.EAP_DISPLAY_NAME+" application";
              this.commonService.getMenu(model).subscribe((result) => {
                this.menuItems = result;
                this.setMenuItems("EAP");
              })
            }
         });                
        }
        else {
          model.Id = this.menudata.appId;
          model.Code = "EAP";
          model.State =  this.getOperation("EAP");
          model.Operation = this.operation;
          model.TargetForm = this.tagetFrom;

          this.mainHeading = this.operation +" "+OrgDetail.EAP_DISPLAY_NAME+" application";
          if (this.eapapp !== null) {
            this.code = this.eapapp.APPLICATION_CODE;
            this.raisedBy = this.eapapp.PHYSICIANNAME;
            this.created = this.eapapp.CREATEDON;
            this.updated = this.eapapp.UPDATEDON;
            this.commonService.getMenu(model).subscribe((result) => {
              this.menuItems = result;
              this.setMenuItems("EAP");
            })
          }
        }
        break;
    }
  }

  onChangeRoute(route) {
    this.selectedRoute = route;
  }

  getOperation(module: string): string {
    let operation = "";
    switch (module) {
      case "IST":
        if (this.istapp !== null && this.istapp !== undefined) {
          if (this.istapp.STATUS === null)
            operation = "1";
          else
            operation = this.istapp.STATUS + "";
        }
        break;
      case "EAP":
        if (this.eapapp !== null && this.eapapp !== undefined) {
          if (this.eapapp.STATUS === null)
            operation = "1";
          else
            operation = this.eapapp.STATUS + "";
        }
        break;
      case "GRANTS":
        if (this.grantsapp !== null && this.grantsapp !== undefined) {
          if (this.grantsapp.STATUS === null)
            operation = "1";
          else
            operation = this.grantsapp.STATUS + "";
          break;
        }
    }

    return operation;
  }

  // getStatus(statusnum: number, AppID:string): Observable<any> {
  //    return this.summaryService.masterData("api/common/getStateNameByAppID?AppID="+this.requestId+"&StatusCode="+statusnum);
  // }

  setMenuItems(Module: string): void {
    const len = this.menuItems.length;
    this.leftMenuItems = [];
    this.topMenuItems = [];
    this.isSubmit = false;
    this.isRoute = false;
    this.isReturn = false;
    this.isWithdraw = false;
    this.isReject = false;
    this.isOnHold = false;
    this.isRelease = false;
    this.isDiscard = false;
    this.isAssign = false;
    this.IsReviewAvailable = false;
    let createdUserID = "";
    let ISSUBMITRETURN = false;
    switch (Module) {
      case "IST":
        if (this.istapp != null) {
          createdUserID = this.istapp.CREATED_BY_IST;
          ISSUBMITRETURN = this.istapp.ISSUBMITRETURN;
        }
        break;
      case "EAP":
        if (this.eapapp != null) {
          createdUserID = this.eapapp.CREATED_BY_IST;
          ISSUBMITRETURN = this.eapapp.ISSUBMITRETURN;
        }
        break;
      case "GRANTS":
        if (this.grantsapp != null) {
          createdUserID = this.grantsapp.CREATED_BY_GM;
          ISSUBMITRETURN = this.grantsapp.ISSUBMITRETURN;
        }
        break;
    }
    for (let i = 0; i < len; i++) {
      switch (this.menuItems[i].MenuType) {
        case "L": //Left ment items
          this.leftMenuItems.push(this.menuItems[i]);
          break;
        case "T": // Top Menu Items
         if(this.IsOnlyView){
             if(this.menuItems[i].Id!="correspondence_request")
              {
                this.topMenuItems.push(this.menuItems[i]);
              }
          }
          else{
              this.topMenuItems.push(this.menuItems[i]);
          }
          break;
        case "E": // External user Operations
        case "I": // Internal user Operations
        case "O": // Org Admin. user Operations
          if ((this.isOwnUser || (this.isCoOwnUser && this.HasCoOwnerPermission))) {
            switch (this.menuItems[i].Name) {
              case "Submit":
                this.isSubmit = true;
                break;
              case "Route":
                this.isRoute = true;
                break;
              case "Return":
                this.isReturn = true;
                break;
              case "Withdraw":
                this.isWithdraw = true;
                break;
              case "Reject":
                this.isReject = true;
                break;
              case "On-Hold":
                this.isOnHold = true;
                break;
              case "Release":
                this.isRelease = true;
                break;
              case "Discard":
                this.isDiscard = true;
                if (this.menuItems[i].MenuType == "I") {
                  this.isDiscard = false;
                }
                break;
              case "Assign":
                this.isAssign = true;
                break;
              case "setupreview":
                if(this.userType!="E")
                {
                  this.IsReviewAvailable = true;
                }
                break;
            }
          }
          else {

            switch (this.menuItems[i].Name) {
              case "Assign":
                this.isAssign = true;
                break;
              case "Route":
                if (createdUserID == this.userDetails.ID && ISSUBMITRETURN)
                  this.isRoute = true;
                break;
              case "Submit":
                if (createdUserID == this.userDetails.ID) {
                  this.isSubmit = true;
                }
                break;
              case "Discard":
                if (createdUserID == this.userDetails.ID) {
                  this.isDiscard = true;
                }
                break;
              case "setupreview":
                if(this.userType!="E")
                {
                  this.IsReviewAvailable = true;
                }
                break;
            }
          }
          if (this.menuItems[i].Name === "Withdraw")
            this.isWithdraw = true;
          break;
      }
    }

    if ((this.isOwnUser || this.isCoOwnUser) && ISSUBMITRETURN) {
      this.isSubmit = false;
      this.isRoute = false;
      this.isReturn = false;
      this.isWithdraw = false;
      this.isReject = false;
      this.isOnHold = false;
      this.isRelease = false;
      this.isDiscard = false;
      this.isAssign = false;
      this.IsReviewAvailable = false;
    }

    this.commonService.setLeftMenu(this.leftMenuItems);
    this.dataShare.setLeftMenu(this.leftMenuItems);
    this.commonService.setTopMenu(this.topMenuItems);
  }

  preventParent(event) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }

  collapseInfo(moduleId) {
    if (this.selectedRoute === (moduleId + 1)) {
      return false;
    } else {
      return true;
    }
  }



  logout(LogoutReason: string) {
    let orgCode = this.userService.getOrgCode();
    let user = this.userService.getUserDetais();
    localStorage.clear();
    this.userService.clearUserData();
    let browser = this.userService.detectBrowserName();

    let model = new LogOutModel();
    model.Browser = browser.name;
    model.Reason = LogoutReason;
    model.Version = browser.version;
    model.UserId= user.ID;
    
    this.userService.userLogout(model).subscribe(result => {
      if (result.Status == 0) {

        if (orgCode !== null && orgCode !== "undefined" && orgCode !== '') {
          // this.redirectTo(orgCode + '/login');
          window.location.replace(orgCode + '/login');
          //window.location.href = orgCode + '/login';
          //this.router.navigate([orgCode + '/login/']);
        }
        else {
          //this.redirectTo('/login');
          window.location.replace('/login');
          //window.location.href = '/login';
          //this.router.navigate(['login']);
        }
      }
    });


    //this.userService.userLogout().subscribe(result => {
    //  this.router.navigate(['login']);
    //  localStorage.clear();
    //  window.location.reload();
    //})
  }

  operations = [
    //{ name: 'Save', callback: this.save, self: this, icon: 'save' },
    { name: 'Route', callback: this.route, self: this, icon: 'check' },
    { name: 'Return', callback: this.return, self: this, icon: 'undo' },
    { name: 'Reject', callback: this.reject, self: this, icon: 'times' },
    { name: 'On-Hold', callback: this.onHold, self: this, icon: 'pause' },
    { name: 'Release', callback: this.release, self: this, icon: 'play' },
    { name: 'withdraw', callback: this.withdraw, self: this, icon: 'times' }
  ]

  checkOnCallbackOperationhide() {
    this.isChecked = 0;
  }

  checkOnCallbackOperationOn() {
    if (this.isChecked === 0) {
      this.isChecked = 1;
    }
  }

  checkOnCallbackOperationOff() {
    this.isChecked = 2;
  }

  onCallbackOperation(operation) {
    operation.callback();
  }

  save() {
    // this.modalService.show(MessageBoxComponent, { data: { heading: 'Save Request', content: { description: 'The Request ID 1234 has been Saved.' } } })
  }

  submit(action: string) {
    this.commonService.setGlobalDirtyInfo(true);
    if (action == "Submit") {
      this.summaryService.getAppSubmitValidations("api/ISTGeneralInfo/IST_APPSubmitValidation?ApplicationID=" + this.menudata.appId + "&ModuleID=" + this.menudata.module).subscribe((result) => {
        if (result != null && result != undefined) {
          if (result.Status == 0) {
            let modalRef = this.modalService.open(SubmitValidationsComponent, {
              backdrop: false,
              keyboard: false,
              windowClass: 'modal-vlg right modal-right',
              animation: true
            });
            modalRef.componentInstance.Content = {
              heading: 'Add',
              content: { SubmitValidationMsg: result.Data.Validations, ChangeLog: result.Data.ChangeLog, ApplicationID: this.menudata.appId, ModuleID: this.module, SubModuleID: this.SubModule },

            }
          }
          else {
            this.summaryService.getAppSubmitValidations("api/ISTGeneralInfo/IST_APPSubmitChangeLog?ApplicationID=" + this.menudata.appId + "&submodule=" + this.SubModule).subscribe((result) => {
              this.callAction(action);

            });
          }
        }

      });
    }
    else {
      this.callAction(action);
    }
  }
  changeLog() {
    let modalRef = this.modalService.open(ChangeLogComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Add',
      content: { ApplicationID: this.menudata.appId, ModuleID: this.module, SubModuleID: this.SubModule },
    }
  }

  removeLeftMenu() {
    this.leftmenus = [];
    localStorage.setItem('leftmenus', null);
  }

  ReviewLaunch() {
    let ApplicationCode = "";
    let ApplicationId = "";
    let ApplicationStatus;
    switch (this.module.toLowerCase()) {
      case "ist":
        ApplicationId = this.istapp.ID;
        ApplicationCode = this.istapp.APPLICATION_CODE;
        ApplicationStatus = this.istapp.STATUS;

        this.summaryService.getISTApplicationSummary("api/common/getistapp/" + ApplicationId).subscribe(data => {
          this.commonService.removeLeftMenu();
          this.istapp = data;
          this.commonService.appId = data.ID;
          this.commonService.ScreenID = data.ID;
          this.commonService.setISTApp(this.istapp);
          this.menudata = new ModuleMenu();
          this.menudata.module = "IST";
          this.menudata.operation = "Edit";
          this.menudata.appId = this.istapp.ID;
          this.menudata.screenID = this.istapp.ID;
          if (this.istapp.STATUS === null || this.istapp.STATUS === 1)
            this.menudata.formstate = "Draft";
          else
            this.menudata.formstate = this.istapp.CurrentStatusExt;
          this.commonService.setModluleMenu(this.menudata);

          this.header.setHeader(this.menudata);
          this.dataShare.setApplicationID(ApplicationId);
          this.router.navigate(['/home/ist/my-applications/application-ext/:' + ApplicationId + '/schedule_review'], { skipLocationChange: true, queryParams: { id: ApplicationId, app_ext: true, module: "ist", submodule: "ist", screen_type: "my-applications" } })
        });

        break;
      case "eap":
        ApplicationId = this.eapapp.ID;
        ApplicationCode = this.eapapp.APPLICATION_CODE;
        ApplicationStatus = this.eapapp.STATUS;
        break;
      case "grants":
        ApplicationId = this.grantsapp.ID;
        ApplicationCode = this.grantsapp.APPLICATION_CODE;
        ApplicationStatus = this.grantsapp.STATUS;

        let RecordID = "";
        this.summaryService.getISTApplicationSummary("api/common/getgrantsapp/" + ApplicationId).subscribe(data => {
          this.removeLeftMenu();
          let modulecode = "";
          this.grantsapp = data;
          this.menudata = new ModuleMenu();
          this.menudata.module = modulecode;
          this.menudata.operation = "Edit";
          this.menudata.appId = this.grantsapp.ID;
          if (this.grantsapp.STATUS === null)
            this.menudata.formstate = "Draft";
          else
            this.menudata.formstate = this.grantsapp.CurrentStatusExt;

          if (this.SubModule.toLocaleString() === "GRANTSCME") {
            modulecode = "GRANTSCME";
            this.GrantsShare.CMEID.subscribe((x) => {
              RecordID = x;
              this.menudata.module = modulecode;
              this.removeLeftMenu();
              this.header.setHeader(this.menudata);
              this.router.navigate(['/home/grants/my-applications/application-ext/:' + ApplicationId + '/schedule_review'], { skipLocationChange: true, queryParams: { module: "grants", submodule: modulecode, id: RecordID, app_ext: true, screen_type: "my-applications" } })

            })
          }
          else if (this.SubModule.toLocaleString() === "GRANTSSPONSORSHIP") {
            modulecode = "GRANTSSPONSORSHIP";
            this.GrantsShare.SPONSORSHIPID.subscribe((x) => {
              RecordID = x;
              this.removeLeftMenu();
              this.menudata.module = modulecode;
              this.header.setHeader(this.menudata);
              this.router.navigate(['/home/grants/my-applications/application-ext/:' + ApplicationId + '/schedule_review'], { skipLocationChange: true, queryParams: { module: "grants", submodule: modulecode, id: RecordID, app_ext: true, screen_type: "my-applications" } })

            })
          }
          else if (this.SubModule.toLocaleString() === "GRANTSCHARITABLE") {
            modulecode = "GRANTSCHARITABLE";
            this.GrantsShare.CharityID.subscribe((x) => {
              RecordID = x;
              this.removeLeftMenu();
              this.menudata.module = modulecode;
              this.header.setHeader(this.menudata);
              this.router.navigate(['/home/grants/my-applications/application-ext/:' + ApplicationId + '/schedule_review'], { skipLocationChange: true, queryParams: { module: "grants", submodule: modulecode, id: RecordID, app_ext: true, screen_type: "my-applications" } })

            })
          }
        });
        break;
    }
  }



  //if (this.isChecked === 2) {
  //  let modalRef = this.modalService.show(SubmitComponent, {
  //    backdrop: false,
  //    keyboard: false,
  //    ignoreBackdropClick: true,
  //    class: 'modal-vlg modal-full-height modal-right',
  //    animated: true,
  //    data: {
  //      heading: 'Save ' + action + ' Request',
  //      content: { id: this.menudata.appId, action: action, state: this.menudata.formstate, module: this.menudata.module }
  //    }
  //  });
  //  modalRef.content.action.subscribe(result => {
  //    this.router.navigate([this.moduleUrl], { skipLocationChange: true });
  //  })

  //}
  //}

  callAction(action: string) {
    if (action == "Discard") {
      let ApplicationCode = "";
      switch (this.module) {
        case "ist":
          ApplicationCode = this.istapp.APPLICATION_CODE;
          break;
        case "eap":
          ApplicationCode = this.eapapp.APPLICATION_CODE;
          break;
        case "grants":
          ApplicationCode = this.grantsapp.APPLICATION_CODE;
          break;
      }
      const modalRef = this.modalService.open(DeleteBoxComponent, { backdrop: false })
      modalRef.componentInstance.Content =
      {
        heading: 'Confirmation ',
        custommessage: 'You are discarding the application ' + ApplicationCode + '.Do you want to continue?',
        ProceedButtonName: "Yes",
        TerminateButtonName: "Cancel"
      }
      modalRef.result.then(result => {
        if (result == "okclick") {
          let route = new ROUTE();
          route = {
            ID: '',
            COMMENTS: '',
            ASSIGNED_TYPE: '',
            PERSON_ID: '',
            PROGRAM_ID: '',
            APPLICATION_ID: this.menudata.appId,
            STATUS: action,
            MODULE: this.menudata.module,
            COOWNER: ''
          }
          this.UmsummaryService.saveSubmit(route).subscribe(result => {
            if (result.Status === 0) {
              this.commonService.SuccessBanner("Application Discarded successfully");
              this.redirectTo(this.moduleUrl);
            }
            else {
              this.commonService.ValidationBanner(result.Message);
            }
          });


        }
      });
    } else if (action == "ScheduleReview") {
      let ApplicationCode = "";
      let ApplicationStatus;
      switch (this.module.toLowerCase()) {
        case "ist":
          ApplicationCode = this.istapp.APPLICATION_CODE;
          ApplicationStatus = this.istapp.STATUS;
          break;
        case "eap":
          ApplicationCode = this.eapapp.APPLICATION_CODE;
          ApplicationStatus = this.eapapp.STATUS;
          break;
        case "granformstatets":
          ApplicationCode = this.grantsapp.APPLICATION_CODE;
          ApplicationStatus = this.grantsapp.STATUS;
          break;
      }

      let modalRef = this.modalService.open(ScheduleReviewComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-vlg right modal-right',
        animation: true
      });
      modalRef.componentInstance.Content = {
        heading: 'Save ' + action + ' Request',
        content: { id: this.menudata.appId, action: action, state: this.menudata.formstate, module: this.menudata.module, SubModuleID: this.SubModule, appCode: ApplicationCode, appStatus: ApplicationStatus }
      }
      modalRef.result.then(result => {
      });
    }
    else {
      if (this.isChecked === 2) {
        let modalRef = this.modalService.open(SubmitComponent, {
          backdrop: false,
          keyboard: false,
          windowClass: 'modal-lg right modal-right',
          animation: true
        });
        modalRef.componentInstance.Content = {
          heading: 'Save ' + action + ' Request',
          content: {
            id: this.menudata.appId,
            action: action,
            state: this.formState,
            module: this.menudata.module,
            SubModuleID: this.SubModule,
            IsOwner: this.isOwnUser,
            IsCoOwner: this.isCoOwnUser,
            OwnerID: this.OwnerID
          }
        }
        modalRef.result.then(result => {
          this.commonService.removeISTApp();
          this.commonService.removeEAPApp();
          this.commonService.removeGrantsApp();

          this.commonService.appId = "";
          this.commonService.ScreenID = "";
          this.commonService.removeLeftMenu();
          this.redirectTo(this.moduleUrl);
          //this.router.routeReuseStrategy.shouldReuseRoute = function () {
          //  return false;
          //};
          //this.router.navigate([this.moduleUrl], { skipLocationChange: false });
        })
      }
    }

  }

  redirectTo(uri: string) {
    this.commonService.setGlobalDirtyInfo(false);
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri]))
  }

  route(action: string) {
    this.callAction(action);
    //if(this.isChecked === 2){
    //  this.modalService.show(RouteComponent,{class: 'modal-lg modal-full-height modal-right'});
    //}
  }

  return() {
    if (this.isChecked === 2) {
      // this.modalService.open(ReturnComponent, { windowClass: 'modal-lg right modal-right' });
    }
  }

  reject() {
    // if (this.isChecked === 2) {
    //   let modalRef = this.modalService.open(RejectComponent, {
    //     backdrop: false,
    //     keyboard: false,
    //     windowClass: 'modal-lg right modal-right',
    //     animation: true
    //   });
    //   modalRef.componentInstance.Content={
    //     heading: 'Reject',
    //     content: null
    //   }
    // }
  }

  openChangePasswordPopup() {
    let modalRef = this.modalService.open(ChangePasswordComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md mt-5 pt-5',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Change Password',
      content: { old_password_field_req: true }
    }
  }

  openNotificationStorePopup() {
    let modalRef = this.modalService.open(NotificationStoreComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Notifications',
      content: null
    }
    modalRef.result.then(result => {
      this.getNotificationCountInit();
    })
  }

  onHold() {
    // if (this.isChecked === 2) {
    //   let modalRef = this.modalService.open(RejectComponent, {
    //     backdrop: false,
    //     keyboard: false,
    //     windowClass: 'modal-lg right modal-right',
    //     animation: true
    //   });
    //   modalRef.componentInstance.Content= {
    //     heading: 'On-Hold',
    //     content: null
    //   }
    // }
  }

  release() {
    // if(this.isChecked === 2){
    //   let modalRef = this.modalService.show(ReleaseComponent, {
    //     backdrop: false,
    //     keyboard: false,
    //     ignoreBackdropClick: true,
    //     class: 'modal-lg modal-full-height modal-right',
    //     animated: true,
    //     data: {
    //       heading: 'Release',
    //       content: null
    //     }
    //   });
    // }
  }

  withdraw() {
    if (this.isChecked === 2) {
      this.modalService.open(WithdrawComponent, { windowClass: 'modal-lg right modal-right' });
    }
  }

  faqView() {
    let modalRef = this.modalService.open(FaqViewComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Add',
      content: { id: null,
        AppID : this.istapp.ID
       }
    }
    //this.modalService.show(FaqViewComponent,{class: 'modal-lg modal-full-height modal-right'});
  }

  helpView() {
    let path = this.getpath(this.router.url);
    let modalRef = this.modalService.open(HelpViewComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Add',
      content: { id: null, path: path, module: this.module, userType: this.userType }
    }
  }

  documentTemplateView() {
    this.modalService.open(DocumentTemplateComponent,
      { windowClass: 'modal-md right modal-right' });
  }

  close() {
     this.istapp=null;
     this.eapapp=null;
     this.grantsapp=null;
    this.commonService.removeISTApp();
    this.commonService.removeEAPApp();
    this.commonService.removeGrantsApp();
    this.ngbModal.dismissAll();
    this.commonService.appId = "";
    this.commonService.ScreenID = "";
    this.commonService.removeLeftMenu();
    this.isClose = false;
    //this.router.navigate([this.moduleUrl], {skipLocationChange:true})
    this.redirectTo(this.moduleUrl);
  }

  discard() {

  }

  getpath(url: string) {
    // Menu Screens. 1st Level Screens
    // this.commonService.getusertype('api/common/insertsubmit').subscribe(result =>{
    //   this.usertype =result.userType
    // })
    this.userType = this.userService.getUserType();
    let path = "";
    let paths = url.split("/");
    let len = paths.length;
    if (url.split("/").length === 4) {
      path = paths[paths.length - 1];
      this.module = paths[paths.length - 2];
    }
    else {
      // Second level screen
      let fullpath = paths[paths.length - 1];
      path = fullpath.substring(0, fullpath.indexOf("?"));
    }
    return path;
  }

  viewProfile() {
    if (this.isChecked === 2) {
      let modalRef = this.modalService.open(ViewProfileComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-md pt-5',
        animation: true
      });
      modalRef.componentInstance.Content = {
        heading: 'On-Hold',
        content: null
      }
    }
  }

  viewAppInfo(){
    let modalRef = this.modalService.open(ApplicationInfoComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md pt-5',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Application Info',
      content: null,
      raisedBy: this.raisedBy,
      updated: this.updated,
      created: this.created,
      MappedApplicationType : this.MappedApplicationType, 
      MappedWorkFlowName : this.MappedWorkFlowName,
      userType:this.userType
    }
  }

  getNotificationCount() {
    this.timeout = setTimeout(() => {
      this.notificationCount = this.commonService.getNotificationCount();
      // Call recursively
      this.getNotificationCount();
    }, 3900000);
  }

  getNotificationCountInit() {
    // this.commonService.getNotificationCount().subscribe(result => {
    //   this.notificationCount = result;
    this.notificationCount = this.commonService.getNotificationCount();
    this.getNotificationCount();
    // })
  }
}
